import { firebaseDb, uid } from './index'

export const getProjectList = (dispatch, onSuccess) => {
  firebaseDb().ref(`users/${uid()}`).once('value')
    .then((snapshot) => {
      if (snapshot.exists()) {
        dispatch(onSuccess(snapshot.val()))
      } else {
        dispatch(onSuccess({projects: undefined}))
      }
    }
  )
}

export const addProject = (name, dispatch, onSuccess) => {
  const projectRef = firebaseDb().ref(`users/${uid()}/projects`)
  let newProjectRef = projectRef.push()
  const key = newProjectRef.key
  newProjectRef.set({name: name, c: new Date(Date.now()).toISOString()})
    .then(() => {
      firebaseDb().ref('parcels').child(key).set(true)
        .then(() => {
          dispatch(onSuccess(key, name))
        })
        .catch((error) => {
          console.log(error)
        })
    })
    .catch((error) => {
      console.log(error)
    })
}


export const renameProject = (id, name, dispatch, onSucess) => {
  firebaseDb().ref(`users/${uid()}/projects/${id}`).child('name').set(name)
    .then(() => {
      dispatch(onSucess(id, name))
    })
    .catch((error) => {
      console.log(error)
    })
}

export const deleteProjects = (deletedPids, dispatch, onSucess) => {
  let updates = {}
  for (let pid in deletedPids) {
    updates[`users/${uid()}/projects/${deletedPids[pid]}`] = null
    updates[`parcels/${deletedPids[pid]}`] = null
    updates[`owners/${deletedPids[pid]}`] = null
  }
  firebaseDb().ref().update(updates)
    .then(() => {
      dispatch(onSucess(deletedPids))
    })
    .catch((error) => {
      console.log(error)
    })
}

export const saveMoySet = (dispatch, onSuccess, moySet, projectId, operation) => {
  firebaseDb().ref(`users/${uid()}/projects/${projectId}`).once('value')
    .then((snapshot) => {
      if (snapshot.exists()) {
        const val = snapshot.val()
        if (val.name) {
          firebaseDb().ref(`users/${uid()}/projects/${projectId}`).child(`moy/${operation}`).set(moySet)
            .then(() => {
              dispatch(onSuccess(moySet, projectId, operation))
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          const pd = {
            name: val,
            moy: moySet
          }
          firebaseDb().ref(`users/${uid()}/projects/${projectId}`).set(pd)
            .then(() => {
              dispatch(onSuccess(moySet, projectId, operation))
            })
            .catch((error) => {
              console.log(error)
            })
        }
      } else {
        dispatch(onSuccess({ projects: undefined }))
      }
    })  
}



// WEBPACK FOOTER //
// ./src/Firebase/apiProjects.js